import "@fontsource/roboto-slab";
import "@fontsource/arimo";
import "../styles/globals.css"; // includes reset
import "./globals.css";
import "./petra.sass";

import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { trackRouteChange } from "./analytics/wrappers";
import { routeTree } from "./routeTree.gen";

const router = createRouter({
  routeTree,
  context: {},
  defaultPreload: false,
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  // defaultErrorComponent: ({error}) => {
  //   <ErrorFallback error={error}  />
  // }
  // defaultOnCatch: ( error ) => {
  //   console.log("Error caught in router: ", error)
  //   void appsignal.sendError(error, {});
  // }
});

router.subscribe("onBeforeNavigate", ({ toLocation }) => {
  // appsignal.addBreadcrumb({
  //   category: "navigation",
  //   action: `Navigating to ${toLocation.href}`,
  // });

  trackRouteChange(toLocation.pathname);
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
  createRoot(rootElement).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );
}
